var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { HttpClient } from '@angular/common/http';
import { StatsResponse } from './stats.model';
import { AppConfigService } from '../shared/services/app-config.service';
import { CrazyCallConfigService } from '../shared/services/crazycall-config.service';
import { EmptyObservable } from 'rxjs-compat/observable/EmptyObservable';
import { disabledProgress } from '../../config/progress.inteceptor';
var StatsService = /** @class */ (function () {
    function StatsService(http, appConfigService, crazyCallConfigService) {
        this.http = http;
        this.appConfigService = appConfigService;
        this.crazyCallConfigService = crazyCallConfigService;
    }
    /* Currently API Gateway cannot correctly deserialize arrays in query params
      https://stackoverflow.com/questions/43401777/passing-array-query-parameters-with-api-gateway-to-lambda
      so we have to convert list to comma separated string manually
    */
    StatsService.prototype.getStats = function (filters) {
        if (!filters.projects || !filters.projects.length) {
            return new EmptyObservable();
        }
        var projectIds = filters.projects.join(',');
        var dateParams = this.mapDateParams(filters.dateRange);
        var disableProgressBar = filters.liveModeEnabled ? disabledProgress : {};
        return this.http.get(this.statsUrl, __assign({ params: __assign({ account: this.crazyCallConfigService.account }, dateParams, { projectIds: projectIds }) }, disableProgressBar));
    };
    Object.defineProperty(StatsService.prototype, "statsUrl", {
        get: function () {
            return "" + this.appConfigService.WEB_CALL_BACKEND_CONFIGURATOR_URL + this.crazyCallConfigService.appId + "/reports/stats";
        },
        enumerable: true,
        configurable: true
    });
    StatsService.prototype.mapDateParams = function (_a) {
        var dateFrom = _a.dateFrom, dateTo = _a.dateTo;
        var params = { dateTo: dateTo.toISOString() };
        if (dateFrom && dateFrom.toISOString()) {
            params['dateFrom'] = dateFrom.toISOString();
        }
        return params;
    };
    return StatsService;
}());
export { StatsService };
